import { Breakpoints, appHeaderHeight, copilotPanelWidth } from '@careerhub/common';
import { makeStyles, tokens, shorthands } from '@fluentui/react-components';

export const useAppStyles = makeStyles({
  skipLink: {
    position: 'absolute',
    top: '-100px',
    left: '8px',
    backgroundColor: tokens.colorNeutralBackground1,
    color: tokens.colorNeutralForeground1,
    padding: '8px 16px',
    zIndex: 9999,
    textDecoration: 'none',
    borderRadius: tokens.borderRadiusMedium,
    ...shorthands.border('1px', 'solid', tokens.colorNeutralStroke1),
    transitionProperty: 'top',
    transitionDuration: tokens.durationFast,
    ':focus': {
      top: '8px',
      outlineStyle: 'solid',
      outlineWidth: '2px',
      outlineColor: tokens.colorStrokeFocus2,
    },
  },

  header: {
    height: appHeaderHeight,
    display: 'flex',
    backgroundColor: tokens.colorNeutralBackground2,
    position: 'sticky',
    top: 0,
    width: '100%',
    zIndex: 3,
  },

  appTaskModuleContainer: {
    width: '100%',
  },

  signInContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    height: '100vh',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    flexDirection: 'row',
  },

  signInText: {
    display: 'flex',
    flexWrap: 'wrap',
    width: '60%',
    justifyContent: 'space-evenly',
    flexDirection: 'column',
    alignItems: 'flex-start',
    marginLeft: '40px',
    ...shorthands.gap('20px'),
  },

  signInButton: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  chatPanel: {
    position: 'fixed',
    display: 'flex',
    alignItems: 'stretch',
    right: 0,
    bottom: 0,
    height: `100vh`,
  },

  contentHeight: {
    maxHeight: `calc(100vh - ${appHeaderHeight})`,
    height: `calc(100vh - ${appHeaderHeight})`,
    [Breakpoints.m]: {
      maxHeight: '100%',
      height: '100%',
    },
  },

  content: {
    backgroundColor: tokens.colorNeutralBackground3,
    ...shorthands.flex(1, 1, 'auto'),
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    marginRight: copilotPanelWidth,
    '@media (max-width: 500px)': {
      marginRight: '0px',
    },
  },
});
